<template>
  <div class="flex flex-col gap-4">
    <!-- Header skeleton -->
    <div class="flex flex-row gap-2 items-center">
      <div class="w-6 h-6 rounded-full bg-gray-800" />
      <div class="h-6 bg-gray-800 rounded w-48" />
    </div>

    <!-- Grid skeleton -->
    <div class="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-6">
      <ModBlockSkeleton v-for="i in skeletonCount" :key="i" />
    </div>
  </div>
</template>

<script setup>
import {
  computed, ref, onMounted, onUnmounted,
} from 'vue';
import ModBlockSkeleton from './ModBlockSkeleton.vue';

const props = defineProps({
  count: {
    type: Number,
    required: false,
    default: 4,
  },
});

// Reactive screen width detection (same logic as ContentRow)
const screenWidth = ref(window.innerWidth);

const updateScreenWidth = () => {
  screenWidth.value = window.innerWidth;
};

onMounted(() => {
  window.addEventListener('resize', updateScreenWidth);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateScreenWidth);
});

// Determine skeleton count based on screen size
const skeletonCount = computed(() => {
  if (screenWidth.value > 2000) {
    return Math.min(props.count, 5);
  } if (screenWidth.value >= 1280) {
    return Math.min(props.count, 4);
  } if (screenWidth.value >= 768) {
    return Math.min(props.count, 3);
  }
  return 1;
});
</script>
